module.exports = __webpack_public_path__ + "static/media/back_of_left_hand_failed.66615f36.svg";